import { CoursesSection } from "./components/CoursesSection";
import OffersSection from "./components/OffersSection";
import Hero from "../../../components/Hero";
import { useParams } from "react-router-dom";

function CoursesAndOffersPage() {
    const { school_level,grade } = useParams();
    let year;
    if (grade === "1") {
        year = "الصف الأول الثانوي";
    }
    else if (grade === "2") {
        year = "الصف الثاني الثانوي";
    }
    else if (grade === "3") {
        year = "الصف الثالث الثانوي";
    }

    const filterButtons = [
        { field: "type", type: "online", value: "1", label: "اونلاين" },
        { field: "type", type: "offline", value: "2", label: "سنتر" },
    ];

    return (
        <>
            <Hero
                title="مادة اللغه العربية"
                description={year}
                pagesLinks={[
                    { name: year, link: `${school_level}/${grade}/courses` },
                    { name: "الصفحة الرئيسية", link: "/" },
                ]}
            />

            <CoursesSection filterButtons={filterButtons} />

            <OffersSection />
        </>
    );
}

export default CoursesAndOffersPage;
